import { TextInput } from '@tremor/react';
import { ReactElement } from 'react';
interface TextFieldROProps {
  label: string;
  attribute: string;
  value: string;
  isDisabled?: boolean;
}
const TextFieldRO = ({
  label,
  attribute,
  value,
  isDisabled = false
}: TextFieldROProps): ReactElement => {
  return <div data-sentry-component="TextFieldRO" data-sentry-source-file="textFieldRO.tsx">
      <label htmlFor={attribute}>{label}</label>
      <TextInput id={attribute} value={value} readOnly className='custom-text-input' disabled={isDisabled} data-sentry-element="TextInput" data-sentry-source-file="textFieldRO.tsx" />
    </div>;
};
export default TextFieldRO;